import React, { useState } from 'react';
import ModalDialog from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button';
import Spinner from '@atlaskit/spinner';
import axios from 'axios';
import Config from '../config';
import InputMask from 'react-input-mask';
import Footer from './footer';
import cross from '../../webjam/components/img/cross.png';

const { socket_endpoint } = Config;

var url = window.location.href.replace(/\/$/, '');
var lastSeg = url.substr(url.lastIndexOf('/') + 1);
import { messages } from '../welcome-dashboard/messages';
import Toast from 'react-simple-toasts';
import { apiVersion } from "../welcome-dashboard/Utils";
import { sendAnalytics } from '../../analytics';
import { getBaseConfig } from '../Utils';
import { Constant } from '../../webjam/constant';
import { ct } from '../constant-Utils';

const config = {
	headers: {
		'content-type': 'application/json'
	}
};

const AddParticipants = ({ changePopupState }) => {
	const [fields, setFields] = useState({
		email: '',
		number: '',
		isEmailLoading: false,
		isTextLoading: false
	});

	const changeField = ({ target: { name, value } }) => {
		setFields({
			...fields,
			[name]: value
		})
	}

	const copyclipBord = () => {
		var copyText = document.getElementById("clipbord");
		copyText.select();
		copyText.setSelectionRange(0, 99999)
		document.execCommand("copy");
		alert(ct("rta-trmc.dashboard.myRoom.urlCopied"));
	}

	const ValidateEmail = (mail) => {
		if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
			return (true);
		}

		Toast(ct("messages.invalidEmail","messages"), Constant.App.ToastTime.LongCloseTime);
		return (false)
	}

	const sendEmail = () => {
		if (!ValidateEmail(fields.email)) {
			return;
		}

		setFields({
			...fields,
			isEmailLoading: true
		});

		const data = {
			url: window.location.href,
			email: fields.email,
			room: lastSeg
		};

		// API hit to claim room
		axios.post(`${socket_endpoint + (getBaseConfig("apiVersion") || apiVersion)}/send_join_link`, data, config).then(response => {
			setFields({
				...fields,
				isEmailLoading: false,
				email: ''
			});
			if (response.data.status) {
				Toast(ct("messages.emailSendSuccess","messages"), Constant.App.ToastTime.LongCloseTime);
				sendAnalytics({
					action: "toolbar-clicked",
					category: "toolbar",
					source: "add participants send email"
				});
			} else {
				Toast(ct("messages.emailOrTextSendError","messages"), Constant.App.ToastTime.LongCloseTime);
			}
		}).catch(error => {
			Toast(ct("messages.contactAdmin","messages"), Constant.App.ToastTime.LongCloseTime);
		});
	}

	const sendSMS = () => {
		if (!fields.number || fields.number.indexOf('_') !== -1) {
			Toast(ct("messages.verifyContact","messages"), Constant.App.ToastTime.LongCloseTime);
			return;
		}

		setFields({
			...fields,
			isTextLoading: true
		});

		const data = {
			room: lastSeg,
			url: window.location.href,
			number: fields.number
		};

		// API hit to claim room
		axios.post(`${socket_endpoint + (getBaseConfig("apiVersion") || apiVersion)}/send_text_message`, data, config).then(response => {
			setFields({
				...fields,
				isTextLoading: false,
				number: ''
			});
			if (response.data.status) {
				Toast(ct("messages.textSendSuccess","messages"), Constant.App.ToastTime.LongCloseTime);
				sendAnalytics({
					action: "toolbar-clicked",
					category: "toolbar",
					source: "add participants send text"
				});
			} else {
				Toast(ct("messages.emailOrTextSendError","messages"), Constant.App.ToastTime.LongCloseTime);
			}
		}).catch(error => {
			Toast(ct("messages.contactAdmin","messages"), Constant.App.ToastTime.LongCloseTime);
		});
	}

	return (
		<ModalDialog
			heading="Add Participants"
			components={{
				Footer: () => <Footer
					isHide={true}
					onClose={() => changePopupState('')}
					showKeyline={false} />,
				Container: 'div',
			}}
		>

			<div className="add-modal">
				<span className="close custom-close" onClick={() => changePopupState('')}>
					<img src={cross} />
				</span>

				<div className="clipbord-copy">
					<label htmlFor="clipbord">{ct("rta-trmc.dialogs.shareLinkParticipants")}: </label><br />
					<div className="clipbord-text text_field">
						<input
							id="clipbord"
							name="clipbord"
							type="text"
							value={window.location.href}
							className="form-control"
							readOnly
						/>
						<div onClick={copyclipBord} ><i className="fa fa-clipboard fa-2x" aria-hidden="true"></i></div>
					</div>
				</div>

				<div className="email-sending">
					<label htmlFor="email">{ct("rta-trmc.dialogs.email")} : </label><br />
					<div className="email-text text_field">
						<input
							id="email"
							name="email"
							type="text"
							value={fields.email}
							onChange={changeField}
							className="form-control"
							autoComplete="off"
						/>
						{!fields.isEmailLoading ?
							// <Button className="submit-button join-meeting-pass" onClick={sendEmail}>
							<Button className="submit-button join-meeting-pass" onClick={sendEmail}>
								{ct("rta-trmc.rtaInviteModal.sendEmail")}
							</Button> :
							// <Button className="submit-button join-meeting-pass">
							<Button className="submit-button join-meeting-pass">
								{ct("rta-trmc.rtaInviteModal.sendEmail")}
							</Button>
							// <Button className="submit-button join-meeting-pass" ><Spinner size="small" /> </Button>
						}
					</div>
				</div>

				<div className="email-sms">
					<label htmlFor="number">{ct("rta-trmc.rtaInviteModal.rtaInviteModal")}: </label><br />
					<div className="sms-text text_field">
						<InputMask
							id="number"
							name="number"
							type="text"
							value={fields.number}
							onChange={changeField}
							mask="(999) 999-9999"
							placeholder="(999) 999-9999"
							className="form-control"
							autoComplete="off"
						/>
						{!fields.isTextLoading ?
							// <Button className="submit-button join-meeting-pass" onClick={sendSMS}>
							<Button className="submit-button join-meeting-pass" onClick={sendSMS}>
								{ct("rta-trmc.rtaInviteModal.sendTextBtn")}
							</Button> :
							// <Button className="submit-button join-meeting-pass">
							<Button className="submit-button join-meeting-pass" onClick={sendSMS}>
								{ct("rta-trmc.rtaInviteModal.sendTextBtn")}
							</Button>
							//    <Button className="submit-button join-meeting-pass" ><Spinner size="small" /> </Button>
						}
					</div>
				</div>
			</div>
		</ModalDialog>
	)
}

export default AddParticipants;